<div class="header-wrapper">
  <div>
    <h3 class="header">{{ 'APPS.title' | translate }}</h3>
  </div>
  <div class="search-container">
    <div class="search">
      <form>
        <mat-form-field floatLabel="always" appearance="outline">
          <mat-label class="mat-label">{{
            'SEARCH.search' | translate
          }}</mat-label>
          <input
            id="search"
            #search
            matInput
            (keyup)="monitorSearch(search.value)"
            [placeholder]="'App_Placeholder' | translate"
          />
          <button
            type="button"
            mat-icon-button
            matSuffix
            (click)="monitorSearch(search.value)"
          >
            <mat-icon>search</mat-icon>
          </button>
        </mat-form-field>
      </form>
    </div>
  </div>
</div>

@if (noRecordFound) {
<app-not-found [displayMessage]="message"></app-not-found>
}

<div class="card-container">
  @for (app of apps; track app; let i = $index) {
  <mat-card
    class="home-card mat-elevation-z6"
  >
    <div class="top-section">
      <img
        mat-card-image
        [src]="
          app && app.logoUri ? app.logoUri : './../assets/img/allegion-card.svg'
        "
        alt=""
        class="icon"
      />
    </div>

    <div class="bottom-section">
      <div class="name" [title]="app.name">
        {{ app.name }}
      </div>
      @if (!app.description) {
      <div class="default-description">
        {{ 'APP_DETAILS.default_description' | translate }}
      </div>
      }
      @if (app.description) {
      <div
        class="default-description"
        [matTooltip]="app.description"
      >
        {{ descriptionDisplay(app.description) }}
      </div>
      }
    </div>
    <mat-card-actions>
      @if (app.isUserAdmin) {
      <button
        mat-stroked-button
        color="primary"
        (click)="navigateToUserPage(app)"
      >
        <mat-icon>people</mat-icon>
        {{ 'Application_Setup.manage_users' | translate }}
      </button>
      }

      @if (app.roles.length <= 0 && userAppManager) {
      <button
        mat-button
        mat-stroked-button
        color="primary"
        (click)="navigateToAppSetup(app)"
        class="setup-button"
      >
      <mat-icon>settings</mat-icon>
        {{ 'Application_Setup.header' | translate }}
      </button>
      }
    </mat-card-actions>
  </mat-card>
  }
  @if (_appsService.loading) {
  <app-spinner></app-spinner>
  }
</div>
